import React, { Component } from "react";
import { Link } from "react-router-dom";

class AccountHomeButton extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="account-home-btn">
          <Link to="/" className="text-white">
            <i className="mdi mdi-home h1" style={{ color: "#3FA7D6" }}></i>
          </Link>
        </div>
      </React.Fragment>
    );
  }
}

export default AccountHomeButton;
